import React from 'react';
import { motion } from 'framer-motion';
import akonLogo from '../../assets/partner/akon.jpg';
import metxLogo from '../../assets/partner/metx.jpg';
import sandalyeciLogo from '../../assets/partner/sandalyeci.jpg';
import './CustomerLogos.css';

const CustomerLogos = () => {
  const logos = [
    {
      name: 'Akon',
      image: akonLogo,
      alt: 'Akon Logo'
    },
    {
      name: 'Metx',
      image: metxLogo,
      alt: 'Metx Logo'
    },
    {
      name: 'Sandaleyeci',
      image: sandalyeciLogo,
      alt: 'Sandaleyeci Logo'
    }
  ];

  return (
    <section className="customer-logos section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Müşteri Memnuniyeti</h2>
          <p className="section-subtitle">
            Bize güvenen değerli müşterilerimiz
          </p>
        </motion.div>

        <motion.div
          className="logos-grid"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          {logos.map((logo, index) => (
            <motion.div
              key={index}
              className="logo-item"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <img 
                src={logo.image} 
                alt={logo.alt}
                className="logo-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  if (e.target.nextSibling) {
                    e.target.nextSibling.style.display = 'flex';
                  }
                }}
              />
              <div className="logo-placeholder" style={{ display: 'none' }}>
                {logo.name}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default CustomerLogos;

